import { useQuery } from "react-query";
import { REQUEST_SIGNUP_OTP } from "../appConstants/APIEndpoint";
import { requestApiPost } from "./index";
// import { appPackageName } from '@env';

export const requestOtp = async (
  phoneNumber: string,
  action: string,
  userResendOtp: boolean,
  language: string
) => {
  const body = {
    phoneNumber,
    action,
    // appPackageName,
    userResendOtp,
  };
  const config = { headers: { language } };
  try {
    const responseData = await requestApiPost(REQUEST_SIGNUP_OTP, body, config);
    return responseData.response;
  } catch (error) {
    console.error("Error requesting OTP:", error);
    // throw error;
  }
};

export const useRequestOtpApi = (
  phoneNumber: string,
  action: string,
  userResendOtp: boolean,
  language: string
) => {
  const { refetch, data, isLoading, error, isError } = useQuery({
    queryKey: ["requestOtpApi", phoneNumber, action, userResendOtp, language],
    queryFn: () => requestOtp(phoneNumber, action, userResendOtp, language),
    staleTime: 0,
    enabled: false, // We're setting it false so it's called only using refetch
  });

  return {
    otpData: data,
    isLoadingOTP: isLoading,
    errorOTP: error,
    isErrorOTP: isError,
    refetchOTP: refetch,
  };
};
